{
  "familyId": "SPR-KLANK-BAKKER",
  "questions": [
    {
      "id": "SPR-KLANK-BAKKER-001",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Iemand die bakt, is een ...",
      "options": ["bakker", "baker", "backer", "baakker"],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "bakker",
            "syllables": ["bak", "ker"],
            "types": ["closed", "closed"],
            "label": "bak·ker — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank (a, e, i, o, u) in een gesloten lettergreep? Dan verdubbel je de medeklinker erachter. Zo blijft de klank kort: bak → bak-ker (niet ba-ker, want dan wordt de 'a' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_kk",
      "variantIndex": 1,
      "citoDifficulty": 0.20,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Het woord 'bakker' heeft een korte 'a'. Als je de lettergrepen splitst, krijg je bak-ker. De 'k' wordt verdubbeld zodat de eerste lettergreep gesloten blijft en de 'a' kort klinkt. Schrijf je 'baker', dan lees je ba-ker met een lange 'a' — en dat is een ander woord!",
        "solutionSteps": [
          "Luister naar de klinker: de 'a' in 'bak' is kort",
          "Een korte klinker staat in een gesloten lettergreep (eindigt op een medeklinker)",
          "Verdubbel de medeklinker: bak → bak-ker",
          "Check: bak-ker — de 'a' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De korte 'a' in 'bak' zorgt ervoor dat de 'k' verdubbeld wordt: bak-ker.",
          "1": "Je dacht waarschijnlijk dat één 'k' genoeg is. Maar 'baker' lees je als ba-ker, met een lange 'a'. De dubbele 'k' houdt de lettergreep gesloten: bak-ker. Onthoud: korte klank → dubbele medeklinker.",
          "2": "Je schreef 'ck' zoals in het Engels (back, pack). Maar in het Nederlands schrijf je een dubbele 'k': bakker, niet backer. Onthoud: Nederlands gebruikt kk, niet ck.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'aa' maakt de klank juist lang. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: bak-ker."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 1 },
          { "id": "spr.english-ck-spelling", "label": "Engelse ck-spelling toegepast", "optionIndex": 2 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-002",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De zwemmer traint elke dag. Welke spelling is goed?",
      "options": ["zwemer", "zweemer", "zwemmer", "zwammer"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zwemmer",
            "syllables": ["zwem", "mer"],
            "types": ["closed", "closed"],
            "label": "zwem·mer — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel",
            "content": "Hoor je een korte klank? Verdubbel de medeklinker erachter. Zwem heeft een korte 'e', dus: zwem-mer (niet zwe-mer, want dan wordt de 'e' lang).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_mm",
      "variantIndex": 2,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Het woord 'zwemmer' heeft een korte 'e'. De 'm' wordt verdubbeld zodat de lettergreep gesloten blijft: zwem-mer. Schrijf je 'zwemer', dan lees je zwe-mer met een lange 'e' — en dat klinkt verkeerd.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'zwem' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zwem → zwem-mer",
          "Check: zwem-mer — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'm' genoeg is. Maar 'zwemer' lees je als zwe-mer, met een lange 'e'. De dubbele 'm' houdt de klank kort: zwem-mer. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker: zwem-mer.",
          "2": "Goed! De korte 'e' in 'zwem' zorgt voor een dubbele 'm': zwem-mer.",
          "3": "Je schreef de verkeerde klinker. Het woord komt van 'zwemmen' met een korte 'e', niet van een 'a'-klank. Luister goed: zwém-mer, niet zwám-mer. Onthoud: de klinker in de stam bepaalt de spelling."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 0 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 1 },
          { "id": "spr.wrong-vowel-stem", "label": "Verkeerde klinker uit stam", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-003",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "We gaan morgen hard ... (rennen). Welke spelling is goed?",
      "options": ["renen", "rennen", "rannen", "reenen"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "rennen",
            "syllables": ["ren", "nen"],
            "types": ["closed", "closed"],
            "label": "ren·nen — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Ook bij werkwoorden geldt de bakker-regel. 'Ren' heeft een korte 'e', dus het hele werkwoord is ren-nen. De 'n' wordt verdubbeld om de korte klank te bewaren.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_nn_werkwoord",
      "variantIndex": 3,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het werkwoord 'rennen' heeft een korte 'e'. De 'n' wordt verdubbeld: ren-nen. Zo blijft de eerste lettergreep gesloten en de 'e' kort. Schrijf je 'renen', dan lees je re-nen met een lange 'e'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'ren' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: ren → ren-nen",
          "Check: ren-nen — de 'e' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'n' genoeg is. Maar 'renen' lees je als re-nen, met een lange 'e'. De dubbele 'n' houdt de klank kort: ren-nen. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Goed! De korte 'e' in 'ren' zorgt voor een dubbele 'n': ren-nen.",
          "2": "Je schreef de verkeerde klinker. Het woord komt van 'rennen' met een korte 'e', niet van een 'a'-klank. Luister goed: rén-nen, niet rán-nen. Onthoud: de klinker in de stam bepaalt de spelling.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'ee' maakt de klank lang (renen → re-nen). Bij de bakker-regel verdubbel je de medeklinker: ren-nen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 0 },
          { "id": "spr.wrong-vowel-stem", "label": "Verkeerde klinker uit stam", "optionIndex": 2 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-004",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De kat zit op de stoel. Ze is lekker aan het ... (zitten).",
      "options": ["ziten", "zutten", "zieten", "zitten"],
      "correctAnswer": 3,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "zitten",
            "syllables": ["zit", "ten"],
            "types": ["closed", "closed"],
            "label": "zit·ten — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij werkwoorden",
            "content": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Zo blijft de lettergreep gesloten en de 'i' kort.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_werkwoord",
      "variantIndex": 4,
      "citoDifficulty": 0.24,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Het werkwoord 'zitten' heeft een korte 'i'. De 't' wordt verdubbeld: zit-ten. Schrijf je 'ziten', dan lees je zi-ten met een lange 'i' — en dat klinkt als 'zijten'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'i' in 'zit' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: zit → zit-ten",
          "Check: zit-ten — de 'i' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'ziten' lees je als zi-ten, met een lange 'i'. De dubbele 't' houdt de klank kort: zit-ten. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je schreef de verkeerde klinker. Het woord komt van 'zitten' met een korte 'i', niet van een 'u'-klank. Luister goed: zít-ten, niet zút-ten. Onthoud: de klinker in de stam bepaalt de spelling.",
          "2": "Je dacht waarschijnlijk dat de klinker verandert. Maar 'ie' is een andere klank dan 'i'. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: zit-ten.",
          "3": "Goed! De korte 'i' in 'zit' zorgt voor een dubbele 't': zit-ten."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 0 },
          { "id": "spr.wrong-vowel-stem", "label": "Verkeerde klinker uit stam", "optionIndex": 1 },
          { "id": "spr.vowel-changed-instead", "label": "Klinker veranderd i.p.v. medeklinker verdubbeld", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-005",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "Welk woord is goed geschreven?",
      "options": ["stofen", "stoffen", "staffen", "stoofen"],
      "correctAnswer": 1,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "stoffen",
            "syllables": ["stof", "fen"],
            "types": ["closed", "closed"],
            "label": "stof·fen — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel herkennen",
            "content": "Kijk naar de eerste lettergreep. Is de klinker kort? Dan moet de lettergreep gesloten zijn (eindigen op een medeklinker). Verdubbel de medeklinker om dat te bereiken: stof → stof-fen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_ff",
      "variantIndex": 5,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Het woord 'stoffen' heeft een korte 'o' in de eerste lettergreep. De 'f' wordt verdubbeld: stof-fen. Schrijf je 'stofen', dan lees je sto-fen met een lange 'o' — en dat klinkt als 'stoven'. Vergelijk: stoffen (materialen) vs. stoven (langzaam koken).",
        "solutionSteps": [
          "Luister naar de klinker: de 'o' in 'stof' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: stof → stof-fen",
          "Check: stof-fen — de 'o' blijft kort ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 'f' genoeg is. Maar 'stofen' lees je als sto-fen, met een lange 'o'. De dubbele 'f' houdt de klank kort: stof-fen. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Goed! De korte 'o' in 'stof' zorgt voor een dubbele 'f': stof-fen.",
          "2": "Je schreef de verkeerde klinker. Het woord komt van 'stof' met een korte 'o', niet van een 'a'-klank. Luister goed: stóf-fen, niet stáf-fen. Onthoud: de klinker in de stam bepaalt de spelling.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'oo' maakt de klank lang. Bij de bakker-regel verdubbel je de medeklinker, niet de klinker: stof-fen."
        }
      },
      "pedagogy": {
        "dok": 1,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 0 },
          { "id": "spr.wrong-vowel-stem", "label": "Verkeerde klinker uit stam", "optionIndex": 2 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-006",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "multiple_choice",
      "question": "De kok maakt soep in een grote ... (pot). Welke spelling van het meervoud is goed?",
      "options": ["poten", "patten", "potten", "pooten"],
      "correctAnswer": 2,
      "stimulusAids": [
        {
          "type": "syllableBlocks",
          "data": {
            "word": "potten",
            "syllables": ["pot", "ten"],
            "types": ["closed", "closed"],
            "label": "pot·ten — twee gesloten lettergrepen"
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "De bakker-regel bij meervoud",
            "content": "Ook bij het meervoud geldt de bakker-regel. 'Pot' heeft een korte 'o', dus het meervoud is pot-ten. De 't' wordt verdubbeld om de korte klank te bewaren. Zonder verdubbeling wordt het 'po-ten' (lange 'o', als in 'poten' van een dier).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "bakker_regel_tt_meervoud",
      "variantIndex": 6,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Het woord 'pot' heeft een korte 'o'. In het meervoud wordt de 't' verdubbeld: pot-ten → potten. Schrijf je 'poten', dan lees je po-ten met een lange 'o' — en dat betekent iets anders (poten van een dier). De verdubbeling houdt de klank kort.",
        "solutionSteps": [
          "Luister naar de klinker: de 'o' in 'pot' is kort",
          "Korte klinker → gesloten lettergreep nodig",
          "Verdubbel de medeklinker: pot → pot-ten",
          "Check: pot-ten (korte 'o') ≠ po-ten (lange 'o', dierenpoten) ✓"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk dat één 't' genoeg is. Maar 'poten' lees je als po-ten, met een lange 'o' — dat zijn poten van een dier! Het meervoud van 'pot' is 'potten'. Onthoud: korte klank → dubbele medeklinker.",
          "1": "Je schreef de verkeerde klinker. Het woord komt van 'pot' met een korte 'o', niet van een 'a'-klank. Luister goed: pót-ten, niet pát-ten. Onthoud: de klinker in de stam bepaalt de spelling.",
          "2": "Goed! De korte 'o' in 'pot' zorgt voor een dubbele 't': pot-ten → potten.",
          "3": "Je dacht waarschijnlijk dat de klinker verdubbeld moet worden. Maar 'oo' maakt de klank lang (zoals in 'boot'). Bij de bakker-regel verdubbel je de medeklinker: pot-ten."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "spr.single-consonant-long-vowel", "label": "Enkele medeklinker geeft lange klank", "optionIndex": 0 },
          { "id": "spr.wrong-vowel-stem", "label": "Verkeerde klinker uit stam", "optionIndex": 1 },
          { "id": "spr.vowel-doubled-instead", "label": "Klinker verdubbeld i.p.v. medeklinker", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-007",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "categorize",
      "question": "Sorteer deze woorden: welke zijn GOED en welke zijn FOUT gespeld?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "categories": ["Goed gespeld", "Fout gespeld"],
        "items": [
          { "text": "bakker", "correctCategory": 0 },
          { "text": "zwemer", "correctCategory": 1 },
          { "text": "rennen", "correctCategory": 0 },
          { "text": "zitten", "correctCategory": 1 },
          { "text": "stoffen", "correctCategory": 0 },
          { "text": "poten (mv. van pot)", "correctCategory": 1 }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De bakker-regel", "content": "Bij een korte klank verdubbel je de medeklinker:\nbakker ✓ (korte a → dubbele k)\nzwemmer ✓ (korte e → dubbele m)\nrennen ✓ (korte e → dubbele n)\nzitten ✓ (korte i → dubbele t)\nstoffen ✓ (korte o → dubbele f)\npotten ✓ (korte o → dubbele t)", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_categorize",
      "variantIndex": 7,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Goed gespeld: bakker (bak-ker), rennen (ren-nen), stoffen (stof-fen) — de medeklinker is verdubbeld om de korte klank te bewaren. Fout gespeld: zwemer (moet zwemmer zijn), ziten (moet zitten zijn), poten als meervoud van pot (moet potten zijn — 'poten' is het meervoud van 'poot', een ander woord!).",
        "solutionSteps": [
          "Luister naar de klinker: kort of lang?",
          "Korte klinker → medeklinker verdubbelen",
          "Goed: bakker, rennen, stoffen (dubbele medeklinker ✓)",
          "Fout: zwemer, ziten, poten (medeklinker niet verdubbeld ✗)"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-008",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "error_spotting",
      "question": "Zoek de spelfouten in deze tekst en verbeter ze.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "text": "De zwemer sprong in het water. Hij rende naar de kant en pakte zijn handoek. Daarna ging hij lekker in de zon zitten.",
        "errors": [
          {
            "word": "zwemer",
            "position": 1,
            "correction": "zwemmer",
            "explanation": "Korte 'e' in 'zwem' → verdubbel de m: zwem-mer."
          },
          {
            "word": "handoek",
            "position": 12,
            "correction": "handdoek",
            "explanation": "'Handdoek' is een samenstelling: hand + doek. De dubbele d komt van de samenstelling."
          },
          {
            "word": "ziten",
            "position": 19,
            "correction": "zitten",
            "explanation": "Korte 'i' in 'zit' → verdubbel de t: zit-ten."
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De bakker-regel", "content": "Bij een korte klank verdubbel je de medeklinker:\nzwem → zwemmer (korte e → dubbele m)\nzit → zitten (korte i → dubbele t)\nLet op: 'handdoek' is een samenstelling (hand + doek).", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_error_spotting",
      "variantIndex": 8,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Drie fouten: 'zwemer' moet 'zwemmer' zijn (korte 'e' → dubbele m), 'handoek' moet 'handdoek' zijn (samenstelling: hand + doek), 'ziten' moet 'zitten' zijn (korte 'i' → dubbele t). Correct: 'rende' en 'pakte' zijn goed gespeld.",
        "solutionSteps": [
          "Fout 1: zwemer → zwemmer (korte 'e' → dubbele m)",
          "Fout 2: handoek → handdoek (hand + doek)",
          "Fout 3: ziten → zitten (korte 'i' → dubbele t)",
          "Correct: rende, pakte ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-009",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "true_false_series",
      "question": "Zijn deze beweringen over de bakker-regel waar of onwaar?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "statements": [
          { "text": "Bij een korte klank verdubbel je de medeklinker.", "isTrue": true },
          { "text": "'Bakker' schrijf je met één k, want de a is kort.", "isTrue": false },
          { "text": "'Zwemmer' heeft een dubbele m omdat de e kort is.", "isTrue": true },
          { "text": "Bij de bakker-regel verdubbel je de klinker.", "isTrue": false },
          { "text": "'Rennen' heeft een dubbele n om de korte e te bewaren.", "isTrue": true }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De bakker-regel", "content": "Bij een korte klank verdubbel je de medeklinker (niet de klinker!). Zo blijft de lettergreep gesloten en de klank kort: bak-ker, zwem-mer, ren-nen.", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_tf_series",
      "variantIndex": 9,
      "citoDifficulty": 0.30,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "De bakker-regel zegt: korte klank → verdubbel de medeklinker (niet de klinker!). Dus 'bakker' heeft wél twee k's (niet één), 'zwemmer' heeft twee m's, en 'rennen' heeft twee n's. Je verdubbelt altijd de medeklinker, nooit de klinker.",
        "solutionSteps": [
          "Stelling 1: Waar ✓ — korte klank → dubbele medeklinker",
          "Stelling 2: Onwaar ✗ — bakker heeft juist twee k's (bak-ker)",
          "Stelling 3: Waar ✓ — zwem-mer, korte e → dubbele m",
          "Stelling 4: Onwaar ✗ — je verdubbelt de medeklinker, niet de klinker",
          "Stelling 5: Waar ✓ — ren-nen, korte e → dubbele n"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-010",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "matching",
      "question": "Koppel elk woord aan de juiste lettergreepverdeling.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "pairs": [
          { "left": "bakker", "right": "bak-ker" },
          { "left": "zwemmer", "right": "zwem-mer" },
          { "left": "rennen", "right": "ren-nen" },
          { "left": "zitten", "right": "zit-ten" },
          { "left": "stoffen", "right": "stof-fen" }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Lettergrepen splitsen", "content": "Bij de bakker-regel splits je het woord op de dubbele medeklinker: bak-ker, zwem-mer, ren-nen, zit-ten, stof-fen. De eerste lettergreep eindigt op een medeklinker (gesloten).", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_matching",
      "variantIndex": 10,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "Bij de bakker-regel splits je het woord op de dubbele medeklinker. Elke eerste lettergreep is gesloten (eindigt op een medeklinker): bak-ker, zwem-mer, ren-nen, zit-ten, stof-fen.",
        "solutionSteps": [
          "Zoek de dubbele medeklinker in elk woord",
          "Splits tussen de twee medeklinkers",
          "bak-ker, zwem-mer, ren-nen, zit-ten, stof-fen"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-011",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "fill_in",
      "question": "Vul het ontbrekende woord in: De ... (van 'lekker') smaakt goed.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["lekker"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De bakker-regel", "content": "'Lek' heeft een korte 'e'. Verdubbel de medeklinker: lek-ker → lekker.", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_fill_lekker",
      "variantIndex": 11,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "'Lekker' heeft een korte 'e' in de eerste lettergreep. De 'k' wordt verdubbeld: lek-ker → lekker. Schrijf je 'leker', dan lees je le-ker met een lange 'e'.",
        "solutionSteps": [
          "Luister naar de klinker: de 'e' in 'lek' is kort",
          "Korte klinker → verdubbel de medeklinker",
          "lek → lek-ker → lekker"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-012",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "fill_in",
      "question": "Schrijf het meervoud van 'nap'. Typ het hele woord.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["nappen"],
        "caseSensitive": false,
        "placeholder": "..."
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "syllableBlocks", "showWhen": "wrong", "data": { "word": "nappen", "syllables": ["nap", "pen"], "types": ["closed", "closed"], "label": "nap·pen — de p wordt verdubbeld" } },
        { "type": "rule", "showWhen": "wrong", "data": { "title": "De bakker-regel bij meervoud", "content": "'Nap' heeft een korte 'a'. Verdubbel de medeklinker: nap → nap-pen → nappen.", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_fill_nappen",
      "variantIndex": 12,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "'Nap' heeft een korte 'a'. In het meervoud verdubbel je de 'p': nap-pen → nappen. Zonder verdubbeling wordt het 'na-pen' met een lange 'a'.",
        "solutionSteps": [
          "'Nap' heeft een korte klank: a",
          "Verdubbel de medeklinker: p → pp",
          "nap-pen → nappen"
        ]
      },
      "pedagogy": {
        "dok": 1
      }
    },
    {
      "id": "SPR-KLANK-BAKKER-013",
      "familyId": "SPR-KLANK-BAKKER",
      "module": "SpellingRegel",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "klankgroepen",
      "subSkill": "klank_gesloten_korte",
      "questionType": "sentence_error_judge",
      "question": "Welke zin bevat een spelfout?",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "sentences": [
          { "text": "De bokser wint de wedstrijd.", "hasError": false, "explanation": "'Bokser' is goed: boks-er. De eerste lettergreep eindigt op twee medeklinkers, dus geen verdubbeling nodig." },
          { "text": "De bakker bakt brood.", "hasError": false, "explanation": "'Bakker' is goed: bak-ker. Korte 'a' → dubbele medeklinker (bakker-regel)." },
          { "text": "We eten lekere koekjes.", "hasError": true, "correction": "We eten lekkere koekjes.", "explanation": "'Lekere' moet 'lekkere' zijn. Lek-ker: korte 'e' → verdubbel de medeklinker (bakker-regel)." },
          { "text": "De loper rent door het park.", "hasError": false, "explanation": "'Loper' is correct: lo-per (open lettergreep, jager-regel — geen verdubbeling)." }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        { "type": "rule", "showWhen": "wrong", "data": { "title": "Wanneer niet verdubbelen?", "content": "Bij 'bokser' eindigt de eerste lettergreep al op twee medeklinkers (boks-). Dan hoef je niet te verdubbelen. Verdubbeling is alleen nodig als er maar één medeklinker staat na de korte klinker.", "icon": "lightbulb" } }
      ],
      "conceptId": "bakker_regel_sentence_judge",
      "variantIndex": 13,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.70,
      "feedback": {
        "explanationText": "'Bokser' is correct gespeld (boks-er). De eerste lettergreep eindigt al op twee medeklinkers (k + s), dus je hoeft niet te verdubbelen. Verdubbeling is alleen nodig als er maar één medeklinker na de korte klinker staat, zoals bij bak-ker. Dit is de bakker-regel.",
        "solutionSteps": [
          "Controleer elk woord op de bakker-regel",
          "'bokser': boks-er — twee medeklinkers na de klinker → geen verdubbeling nodig ✓",
          "'bakker': bak-ker — korte 'a', verdubbelde 'k' → correct ✓",
          "'loper': lo-per — open lettergreep, jager-regel → correct ✓",
          "'lekkere': lek-ke-re — korte 'e', verdubbelde 'k' → correct ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}